import { render, staticRenderFns } from "./edit_service.vue?vue&type=template&id=be145be8&scoped=true&"
import script from "./edit_service.vue?vue&type=script&lang=js&"
export * from "./edit_service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be145be8",
  null
  
)

export default component.exports